import type TokenResponse from 'owa-service/lib/contract/TokenResponse';
import { getTokenCache } from '../getTokenCache';
import type { TokenRequestParams } from 'owa-tokenprovider-utils';
import { getUnifiedTokenCache } from 'auth-token-cache/lib/UnifiedTokenCache';
import { isBootFeatureEnabled } from 'owa-metatags/lib/isBootFeatureEnabled';

export function getCachedTokenIfAvailable(
    tokenRequestParams: TokenRequestParams
): TokenResponse | undefined {
    let cachedToken: TokenResponse | undefined;

    if (isBootFeatureEnabled('auth-unifiedCache')) {
        if (tokenRequestParams.mailboxInfo) {
            const unifiedCache = getUnifiedTokenCache();
            const cacheKey = unifiedCache.getCacheKey(
                tokenRequestParams.mailboxInfo,
                tokenRequestParams.resource,
                tokenRequestParams.scope,
                tokenRequestParams.targetTenantId,
                undefined /* childAppId */
            );
            cachedToken = unifiedCache.getCachedToken(cacheKey);
        }
    } else {
        const tokenCache = getTokenCache();
        const cacheKey = tokenCache.getCacheKey(tokenRequestParams);
        cachedToken = tokenCache.getCachedToken(cacheKey);

        // Check if the cached token is expired
        if (cachedToken?.AccessTokenExpiry) {
            const tokenExpirationTime = new Date(cachedToken.AccessTokenExpiry).getTime();
            if (tokenExpirationTime <= Date.now()) {
                return;
            }
        }
    }

    return cachedToken;
}
